import { useQuery } from "@tanstack/react-query";
import { GamesResponseType } from "../types/Games";
import url from "../url";
import { api } from "../utils/hostname";

type useGetGamesByCategoryParams = {
  take: number;
  categories: string;
  platform: "web" | "mobile";
  inView: boolean;
};
export const useGetGamesByCategory = (params: useGetGamesByCategoryParams) => {
  const { take, categories, platform, inView } = params;
  const { data, isLoading } = useQuery({
    queryKey: ["games", categories],
    queryFn: () =>
      api(true, true, "v2").get<GamesResponseType>(url.config.api.games.games, {
        params: {
          take,
          categories,
          platform,
        },
      }),
    enabled: inView,
    staleTime: 60_000,
  });
  return {
    games: data?.data?.data || [],
    total: data?.data?.total || 0,
    isLoading,
  };
};
